import ReadOnlyAttributeFields from './ReadOnlyAttributeFields'

export default ReadOnlyAttributeFields
